export default __webpack_public_path__ + "static/feed_bg-596ffd2f1cc38d080eedb28758e3bb7e.png";